import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { canUseSuperAdminFeatures } from '../../services/accessManagement/accessManagement';

/** Only the customer-question workspace permits real admins to review while impersonating. */
export function CustomerRequestsAdminRoute({ children }: { children: JSX.Element }) {
  const { user, backendUser, loading } = useAuth();
  const { t } = useTranslation();
  if (loading || (user && !backendUser)) return <div role="status" className="p-6">{t('customerRequests.loading')}</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!canUseSuperAdminFeatures(backendUser)) return <Navigate to="/" replace />;
  return children;
}
